import { render, staticRenderFns } from "./formulator-nutrition.vue?vue&type=template&id=546adf60&scoped=true&"
import script from "./formulator-nutrition.vue?vue&type=script&lang=js&"
export * from "./formulator-nutrition.vue?vue&type=script&lang=js&"
import style0 from "./formulator-nutrition.vue?vue&type=style&index=0&id=546adf60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546adf60",
  null
  
)

export default component.exports